import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));
interface Props {
  setData: any;
  data: Array<any>
}

const AvatarAndName: React.FC<Props> = ({ data, setData }) => {
  const classes = useStyles();

  const handleToggle = (id: string) => {
    setData(data.map((item) => {
      if (item.id === id) {
        item.check = item.check ? !item.check : true;
        return item;
      }
      return item;
    }));
  };

  return (
    <List dense className={classes.root}>
      {data.map((value) => {
        const labelId = `checkbox-list-secondary-label-${value}`;
        return (
          <ListItem key={value.id} button>
            <Checkbox
              edge="end"
              onClick={() => handleToggle(value.id)}
              checked={value.check || false}
              inputProps={{ 'aria-labelledby': labelId }}
              style={{ marginRight: 10 }}
            />
            <ListItemAvatar>
              <Avatar
                alt={`Avatar n°${value + 1}`}
                src={value.nome}
              />
            </ListItemAvatar>
            <ListItemText id={labelId} primary={value.nome} />
          </ListItem>
        );
      })}
    </List>
  );
};
export default AvatarAndName;
